module.exports = __webpack_public_path__ + "static/media/linkedin_original.ab46037f.svg";